import "./info.css";


const Info = () => {
    return (
        <div className='infoStyle'>
            Click on a Building
        </div>
    );
};
export default Info;